import React from 'react';
import keyboard from '../assets/images/keybord.jpeg';
function AdvancedSkills() {
  return (
    <>
      <div className='w-full h-auto sm:h-[78px] bg-[#041a45] text-[16px] leading-[24px] text-start px-[32px]'>
        <p className='w-full h-auto sm:w-[1148px] sm:h-[38px] text-[25.6px] leading-[38.4px] text-start text-white py-[20px] px-[66px]'>
          {' '}
          Do you have digital skills?
        </p>
      </div>

      <div className='w-full h-auto sm:h-[428px] pb-[16px] bg-[#ffffff] flex justify-center items-center'>
        <div className='w-full h-auto flex-wrap sm:w-[1140px] sm:h-[380px] bg-[#041a45] sm:rounded-[30px] mx-[-16px] flex justify-center items-center'>
          <div className='w-full h-auto sm:w-[50%] sm:h-[354px] sm:py-[32px] sm:px-[64px] text-[16px] leading-[24px] text-left text-white my-[13px]'>
            <p className='text-[16px] leading-[24px] text-left twxt-white font-bold my-[32px] mx-[64px]'>
              {' '}
              Lorem ipsum dolor, sit amet consectetur adipisicing elit.
              Inventore corrupti quos ullam reiciendis in ut fugiat, dolorum vel
              officia cumque! Earum pariatur inventore modi exercitationem quo
              amet unde in quisquam!
            </p>
            <div className='w-[60%] margin-auto sm:w-[429px] h-[73px] my-[32px] mx-[64px]'>
              <button className=' w-[213px] h-[53px] px-[56px] py-[12px] my-[9px] mx-[9px] text-[17.6px] leading-[26.4px] text-center text-white font-bold bg-[#ffbd39] rounded-[100px] shadow-[rgba(0, 0, 0, 0.2) 0px 2px 2px 0px]'>
                {' '}
                Get Started
              </button>
            </div>
          </div>
          <div className='w-full h-[400px] sm:w-[50%] sm:h-[354px] pl-[6px] overflow-hidden rounded-lg'>
            <img
              className='w-full h-full'
              src={keyboard}
              alt='missing picture'
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default AdvancedSkills;
